<template>
    <lv-base-column
        ref="column" v-bind="columnBinding">
        <template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
            <lv-column-item
                :row="row"
                :edit-row="editRow"
                :row-index="rowIndex"
                :col="col"
                :col-index="colIndex"
                :fixed-row="fixedRow"
                v-bind="columnItemBinding"
                @click="lv_clickItem"/>
        </template>
    </lv-base-column>
</template>

<script>
    import {ColumnMixin} from "../mixins";
    import LvBaseColumn from "../../table/lv-base-column";
    import LvColumnItem from "./lv-column-item";

    export default {
        name: "lv-column-input",
        components: {LvColumnItem, LvBaseColumn,},
        mixins: [ColumnMixin],
        props: {
            disabledFormEdit: {default: true},
            disabledBatchModify: {default: true},
        },
    }
</script>

<style lang="scss">
    .pl-column-edit-item {
        width: 100%;
    }
</style>
